module.exports = __webpack_public_path__ + "static/media/81mmD104Inox.5d364955.png";